import React from 'react';
import { IMAGES } from '../mock';
import { Rocket, Sigma, Mic, FileText, LineChart, ScrollText, Layers, ShoppingBag } from 'lucide-react';

const BONUS_ICONS = [Rocket, Sigma, Mic, FileText, LineChart, ScrollText, Layers, ShoppingBag];

export default function Bonus() {
  return (
    <section className="gradient-bg-light py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#a020c9] tracking-widest text-sm font-semibold uppercase">— Material Bônus —</p>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#7a1fb0] mt-2">E ainda tem tudo isso</h2>
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {IMAGES.bonus.map((c, i) => {
            const Icon = BONUS_ICONS[i] || Rocket;
            return (
              <div key={i} className="card-course">
                <div className="aspect-square bg-gradient-to-br from-[#7a1fb0] to-[#ec2fd2] flex items-center justify-center text-white">
                  <Icon size={54} />
                </div>
                <div className="p-4">
                  <span className="inline-block text-[10px] font-bold uppercase tracking-wider text-white bg-[#a020c9] rounded px-2 py-1 mb-2">{c.tag}</span>
                  <h3 className="font-heading font-bold text-sm text-[#2b1039] mb-1">{c.title}</h3>
                  <p className="text-xs text-[#5a3a6b] leading-relaxed">{c.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
